import { render, staticRenderFns } from "./PricingDetails.vue?vue&type=template&id=099f2926&"
import script from "./PricingDetails.vue?vue&type=script&lang=ts&"
export * from "./PricingDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports